module.exports = __webpack_public_path__ + "static/img/7.7daa31ef.png";